import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoaderService } from 'src/app/common/loader.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent implements OnInit {

  addCategoryTitle = true;
  editCategoryTitle;
  categoryForm: FormGroup;
  submitted = false;
  partnerTypes: any[];
  constructor(private formBuilder: FormBuilder, private masterService: MasterService,
    private loaderService: LoaderService, private toasterService: ToastrService) {
    this.getFormGroup();
  }

  ngOnInit() {
    this.masterService.getPartnerTypes().subscribe(response => {
      if (response && response['result']) {
        this.partnerTypes = response['result'];
      }
    })
  }


  get f() { return this.categoryForm.controls; }
  private getFormGroup() {
    this.categoryForm = this.formBuilder.group({
      'id': new FormControl(),
      'partnerType': new FormControl(),
      'code': new FormControl(),
      'descEn': new FormControl(),
      'desc': new FormControl(),
      'codeInternational': new FormControl(),
      'codeLocal': new FormControl()
    })
  }

  save() {
    let saveData = {};
    this.submitted = true;
    if (this.categoryForm.invalid) {
      return;
    }
    saveData["master"] = this.categoryForm.value;
    saveData["masterShName"] = "CATEGORY";

    this.loaderService.display(true);
    this.masterService.saveMaster(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["code"] == 0) {
        this.categoryForm.patchValue({ cotryId: response['result'] });
        this.toasterService.success(response['message'], 'Success');
      } else {
        this.toasterService.error(response['message'], 'Error');
      }
    },
      error => {
        this.loaderService.display(false);
      })
  }
}
